import React from 'react'
import { Container, Data, Datum, Label, Value, A, Heading } from './styles'

const ContactDetails = () => (
  <Container>
    <Heading>Contact Details</Heading>
    <Data>
      <Datum>
        <Label>Telephone</Label>
        <Value><A href="tel:+441983402773">01983 402773</A></Value>
      </Datum>

      <Datum>
        <Label>Email Address</Label>
        <Value><A href="mailto:info@chesterlodge.com">info@chesterlodge.com</A></Value>
      </Datum>

      <Datum>
        <Label>Address</Label>
        <Value>7 Beachfield Road, Sandown, Isle of Wight, P036 8NA</Value>
      </Datum>
    </Data>
  </Container>
)

export default ContactDetails
